module.exports = __webpack_public_path__ + "img/Footprint.8eb336d9.svg";